import Decimal from "decimal.js"
import React, { useContext, useMemo } from "react"
import { useMarina } from "src/contexts/MarinaContext"
import { centsToDollars, dollarsToCents } from "src/main/Billing/Items/helpers"
import { POSContext } from "src/main/PointOfSale/Layout"

import LineItems from "src/components/LineItems/LineItems"

import { PaymentFlowContext } from "../PaymentModal"
import { CheckoutContext } from "../index"
import TipInput from "./TipInput"

const ConfirmationTotals = () => {
  const { presentmentCurrency } = useMarina()
  const {
    cartController: { totals, lineItems },
  } = useContext(POSContext)
  const {
    checkoutDetails: { tip, setTip },
    flowDetails: { allowTipsForPaymentFlow },
  } = useContext(PaymentFlowContext)
  const { sale: retrySale } = useContext(CheckoutContext)

  const tipAmount = useMemo(() => {
    if (retrySale?.tip) {
      return centsToDollars(retrySale.tip).toFixed(2).toString()
    } else if (allowTipsForPaymentFlow) {
      return new Decimal(tip).toFixed(2).toString()
    } else {
      return "0.00"
    }
  }, [retrySale, allowTipsForPaymentFlow, tip])

  const totalAmount = useMemo(() => {
    if (retrySale) {
      return centsToDollars(retrySale.total).toFixed(2).toString()
    } else {
      return Decimal.sum(totals.total, tipAmount).toFixed(2).toString()
    }
  }, [retrySale, tipAmount, totals.total])

  const showTipLine = useMemo(() => {
    if (retrySale) {
      return retrySale.tip > 0
    }

    return allowTipsForPaymentFlow
  }, [retrySale, allowTipsForPaymentFlow])

  const lineItemsWithTip = useMemo(() => {
    // Backend lineItems includes subtotal, discount, taxes, and total
    // We keep the total but add tip line before it (if present)
    const items = lineItems.filter((item) => item.type !== "total")

    // Check if backend already included a tip line (happens after sale creation)
    const backendHasTip = items.some((item) => item.label === "Tip")

    // Add tip line if needed (only if not retrying sale and backend hasn't already included it)
    if (showTipLine && !retrySale && !backendHasTip) {
      items.push({
        type: "subtotal",
        label: "Tip",
        amount: dollarsToCents(tipAmount),
      })
    }

    // Add total line with recalculated amount (includes tip)
    items.push({
      type: "total",
      label: "Total",
      amount: dollarsToCents(totalAmount),
    })

    return items
  }, [lineItems, showTipLine, retrySale, tipAmount, totalAmount])

  return (
    <div className="space-y-4 py-4">
      <LineItems
        lineItems={lineItemsWithTip}
        loading={false}
        currency={presentmentCurrency}
        spacing={2}
      />
      <hr />
      {!retrySale && allowTipsForPaymentFlow ? (
        <TipInput tip={tip} setTip={setTip} />
      ) : null}
    </div>
  )
}

export default ConfirmationTotals
